import {SurveyData} from 'screens/InsomniaSurvey/utils/surveyData';

export const getValueFromSurveyData = (value: string) => {
  const surveyData = SurveyData.read();
  const result = surveyData?.[value];
  if (result === undefined) {
    console.error(`Value ${value} not found in survey data`);
  }
  return surveyData?.[value] ?? undefined;
};
